var $protobuf = {util:{},roots:{default:{}}};
// Common aliases
var $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export var SessionHealthEvent = (function() {

    /**
     * Properties of a SessionHealthEvent.
     * @exports ISessionHealthEvent
     * @interface ISessionHealthEvent
     * @property {string|null} [cv] SessionHealthEvent cv
     * @property {string|null} [serviceName] SessionHealthEvent serviceName
     * @property {string|null} [sessionKey] SessionHealthEvent sessionKey
     * @property {string|null} [clientAppName] SessionHealthEvent clientAppName
     * @property {string|null} [clientAppPlatform] SessionHealthEvent clientAppPlatform
     * @property {string|null} [clientRuntimeVersion] SessionHealthEvent clientRuntimeVersion
     * @property {string|null} [clientAppVersion] SessionHealthEvent clientAppVersion
     * @property {string|null} [clientReleaseAudienceGroup] SessionHealthEvent clientReleaseAudienceGroup
     * @property {string|null} [clientReleaseChannel] SessionHealthEvent clientReleaseChannel
     * @property {string|null} [clientReleaseFork] SessionHealthEvent clientReleaseFork
     * @property {string|null} [clientSessionId] SessionHealthEvent clientSessionId
     * @property {string|null} [clientFlights] SessionHealthEvent clientFlights
     * @property {string|null} [clientIPRange] SessionHealthEvent clientIPRange
     * @property {string|null} [clientDocSessionId] SessionHealthEvent clientDocSessionId
     * @property {string|null} [clientDeviceId] SessionHealthEvent clientDeviceId
     * @property {string|null} [clientUserAgent] SessionHealthEvent clientUserAgent
     * @property {string|null} [userType] SessionHealthEvent userType
     * @property {string|null} [userId] SessionHealthEvent userId
     * @property {string} sessionHealthEventName SessionHealthEvent sessionHealthEventName
     * @property {string} source SessionHealthEvent source
     * @property {string} reason SessionHealthEvent reason
     * @property {string|null} [reasonDependency] Used to describe which dependency failed if reason=Dependency
     * @property {string|null} [subReason] SessionHealthEvent subReason
     * @property {string} impact SessionHealthEvent impact
     * @property {boolean} success SessionHealthEvent success
     * @property {number} durationMs SessionHealthEvent durationMs
     * @property {number} count SessionHealthEvent count
     * @property {string} message SessionHealthEvent message
     * @property {string} affectedWorkflows Below field describes which workflows are affected. Special value "All". If WorkflowXyz failed executing value will be ["WorkflowXyz"], if there is a missing input from the client value will be ["All"].
     * We might want to add more fields as service evolves, for example if scenario health/AL service output is no longer solely defined by workflowId.
     * @property {string|null} [resourceId] SessionHealthEvent resourceId
     * @property {string|null} [dimension0] SessionHealthEvent dimension0
     * @property {string|null} [dimension1] SessionHealthEvent dimension1
     * @property {string|null} [dimension2] SessionHealthEvent dimension2
     * @property {string|null} [dimension3] SessionHealthEvent dimension3
     * @property {string|null} [resultDescription] SessionHealthEvent resultDescription
     * @property {string|null} [resultSignature] SessionHealthEvent resultSignature
     * @property {string|null} [joinContextId] SessionHealthEvent joinContextId
     */

    /**
     * Constructs a new SessionHealthEvent.
     * @exports SessionHealthEvent
     * @classdesc Represents a SessionHealthEvent.
     * @implements ISessionHealthEvent
     * @constructor
     * @param {ISessionHealthEvent=} [properties] Properties to set
     */
    function SessionHealthEvent(properties) {
        if (properties)
            for (var prop in properties)
                if (properties[prop] != null)
                    this[prop] = properties[prop];
    }

    /**
     * SessionHealthEvent cv.
     * @member {string} cv
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.cv = "";

    /**
     * SessionHealthEvent serviceName.
     * @member {string} serviceName
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.serviceName = "";

    /**
     * SessionHealthEvent sessionKey.
     * @member {string} sessionKey
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.sessionKey = "";

    /**
     * SessionHealthEvent clientAppName.
     * @member {string} clientAppName
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.clientAppName = "";

    /**
     * SessionHealthEvent clientAppPlatform.
     * @member {string} clientAppPlatform
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.clientAppPlatform = "";

    /**
     * SessionHealthEvent clientRuntimeVersion.
     * @member {string} clientRuntimeVersion
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.clientRuntimeVersion = "";

    /**
     * SessionHealthEvent clientAppVersion.
     * @member {string} clientAppVersion
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.clientAppVersion = "";

    /**
     * SessionHealthEvent clientReleaseAudienceGroup.
     * @member {string} clientReleaseAudienceGroup
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.clientReleaseAudienceGroup = "";

    /**
     * SessionHealthEvent clientReleaseChannel.
     * @member {string} clientReleaseChannel
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.clientReleaseChannel = "";

    /**
     * SessionHealthEvent clientReleaseFork.
     * @member {string} clientReleaseFork
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.clientReleaseFork = "";

    /**
     * SessionHealthEvent clientSessionId.
     * @member {string} clientSessionId
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.clientSessionId = "";

    /**
     * SessionHealthEvent clientFlights.
     * @member {string} clientFlights
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.clientFlights = "";

    /**
     * SessionHealthEvent clientIPRange.
     * @member {string} clientIPRange
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.clientIPRange = "";

    /**
     * SessionHealthEvent clientDocSessionId.
     * @member {string} clientDocSessionId
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.clientDocSessionId = "";

    /**
     * SessionHealthEvent clientDeviceId.
     * @member {string} clientDeviceId
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.clientDeviceId = "";

    /**
     * SessionHealthEvent clientUserAgent.
     * @member {string} clientUserAgent
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.clientUserAgent = "";

    /**
     * SessionHealthEvent userType.
     * @member {string} userType
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.userType = "";

    /**
     * SessionHealthEvent userId.
     * @member {string} userId
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.userId = "";

    /**
     * SessionHealthEvent sessionHealthEventName.
     * @member {string} sessionHealthEventName
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.sessionHealthEventName = "";

    /**
     * SessionHealthEvent source.
     * @member {string} source
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.source = "";

    /**
     * SessionHealthEvent reason.
     * @member {string} reason
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.reason = "";

    /**
     * Used to describe which dependency failed if reason=Dependency
     * @member {string} reasonDependency
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.reasonDependency = "";

    /**
     * SessionHealthEvent subReason.
     * @member {string} subReason
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.subReason = "";

    /**
     * SessionHealthEvent impact.
     * @member {string} impact
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.impact = "";

    /**
     * SessionHealthEvent success.
     * @member {boolean} success
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.success = false;

    /**
     * SessionHealthEvent durationMs.
     * @member {number} durationMs
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.durationMs = 0;

    /**
     * SessionHealthEvent count.
     * @member {number} count
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.count = 0;

    /**
     * SessionHealthEvent message.
     * @member {string} message
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.message = "";

    /**
     * Below field describes which workflows are affected. Special value "All". If WorkflowXyz failed executing value will be ["WorkflowXyz"], if there is a missing input from the client value will be ["All"].
     * We might want to add more fields as service evolves, for example if scenario health/AL service output is no longer solely defined by workflowId.
     * @member {string} affectedWorkflows
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.affectedWorkflows = "";

    /**
     * SessionHealthEvent resourceId.
     * @member {string} resourceId
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.resourceId = "";

    /**
     * SessionHealthEvent dimension0.
     * @member {string} dimension0
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.dimension0 = "";

    /**
     * SessionHealthEvent dimension1.
     * @member {string} dimension1
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.dimension1 = "";

    /**
     * SessionHealthEvent dimension2.
     * @member {string} dimension2
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.dimension2 = "";

    /**
     * SessionHealthEvent dimension3.
     * @member {string} dimension3
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.dimension3 = "";

    /**
     * SessionHealthEvent resultDescription.
     * @member {string} resultDescription
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.resultDescription = "";

    /**
     * SessionHealthEvent resultSignature.
     * @member {string} resultSignature
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.resultSignature = "";

    /**
     * SessionHealthEvent joinContextId.
     * @member {string} joinContextId
     * @memberof SessionHealthEvent
     * @instance
     */
    SessionHealthEvent.prototype.joinContextId = "";

    return SessionHealthEvent;
})();
